const startConfig = require('../apiConfig')
const comHttpUrl = startConfig.baseUrl()

module.exports = {
  carousellist: comHttpUrl + 'banner/list', // 轮播图列表
  newslist: comHttpUrl + 'news/list', // 新闻中心列表
  speciallist: comHttpUrl + 'special/list', // 专题列表
  topiclist: comHttpUrl + 'special/list', // 头条列表
  publicitylist: comHttpUrl + 'publicity/list', // 通知/公示列表
  productlist: comHttpUrl + 'information/list', // 资讯列表
  informationList: comHttpUrl + 'information/typelist', // 咨询类型列表
  magazinelist: comHttpUrl + 'magazine/list', // 杂志列表
  industrylist: comHttpUrl + 'industry/list', // 产业数据库信息列表
  limbolist: comHttpUrl + 'limbo/list', // 林博会列表
  overalllist: comHttpUrl + 'overall/select', // 专题头条图文列表
  zhazhilist: comHttpUrl + 'magazine/list', // 杂志
  forestlist: comHttpUrl + 'forest/list', // 林产品
  friendsurl: comHttpUrl + 'friendship/list', // 友情链接
  producturl: comHttpUrl + 'product/list', // 产品资讯
  advertisingurl: comHttpUrl + 'advertising/list'// 广告列表
}



// WEBPACK FOOTER //
// ./src/api/modules/index.js